export const onWeights = (weights: number, list: { weights?: number }[], suffix = '%') => {
    const selectWeightsList = list.map((item) => Number(item?.weights || 1));
    const sumTotal = selectWeightsList.reduce((prev, next) => prev + next, 0) || 1;

    const rate = ((weights * 100) / sumTotal).toFixed(1).replace(/\.0$/, '');
    return `${rate}${suffix}`;
};
export const isMock = false;
